import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import RangeStatusForm from '../../../components/forms/RangeStatusForm';
import { useRangeStatusById, useUpdateRangeStatus } from '../../../hooks/useRangeStatusApi';
import { useNavigate, useParams } from 'react-router-dom';

const RangeStatusEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData } = useRangeStatusById(id);
  const updateMutation = useUpdateRangeStatus();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Range Statuses', href: '/admin/rangestatuses' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateMutation.mutateAsync({ id: id!, data });
      navigate('/admin/rangestatuses');
    } catch (error) {
      console.error('Error updating RangeStatus:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/rangestatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.RangeStatus.Edit"
    >
        {entityData ? (
          <RangeStatusForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/rangestatuses')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default RangeStatusEdit;
